import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hbnx2me9hg: FaireBrandEntity = {
  token: "b_hbnx2me9hg",
  type: "brand",
  name: "Droosh",
  avatarUrl:
    "https://cdn.faire.com/fastly/7836f59fc810382b022cee1588401eadbc678a5cb69368543aaa68e856465655.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6b201c5d17856b4345e9fd61e336044dd647f5eaec77585af29ecb1996293b65.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7836f59fc810382b022cee1588401eadbc678a5cb69368543aaa68e856465655.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6b201c5d17856b4345e9fd61e336044dd647f5eaec77585af29ecb1996293b65.jpeg",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 60,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Droosh is an AAPI / WOC-owned brand that offers premium and unique spice blends—The Icon, Tikka Masala, Everyday, and Chaat Party— and chutney-inspired hot sauces to simplify and enhance the cooking of Indian and Indian-inspired cuisine. By providing convenient and cost-effective pantry staples, Droosh makes it easier for everyone to enjoy authentic Indian flavors without the hassle of buying and measuring individual ingredients, which can be expensive. \n\nFounders Serena, Savi and Sabrina Rathi want to find a way to spark meaningful conversations around food, culture, community and innovation. Droosh isn’t just another pretty online food brand, they aren’t here to make noise, but to make change. They hope that with Droosh, they can bring a more diverse voice into the conversation around food, culture and educate consumers about Indian cuisine. \n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:50.247Z",
    importedBy: "entity-db-cli",
  },
};
